/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeocodageAdresseResponseDto } from '../../models/geocodage-adresse-response-dto';
import { LocalisationAdresseGeocodageRequestDto } from '../../models/localisation-adresse-geocodage-request-dto';

export interface GeocodeAdresseIntervention$Params {
  idLocalisation: string;
  body: LocalisationAdresseGeocodageRequestDto;
}

export function geocodeAdresseIntervention(
  http: HttpClient,
  rootUrl: string,
  params: GeocodeAdresseIntervention$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<GeocodageAdresseResponseDto>> {
  const rb = new RequestBuilder(rootUrl, geocodeAdresseIntervention.PATH, 'patch');
  if (params) {
    rb.path('idLocalisation', params.idLocalisation, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeocodageAdresseResponseDto>;
    })
  );
}

geocodeAdresseIntervention.PATH = '/v1/localisations/{idLocalisation}/geocode-adresse-intervention';
